export class LoanDenialReasonsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanDenialReasons({ loanId }) {
    return this.#http.get(`/LoanDenialReasons/${loanId}`);
  }

  async updateAllLoanDenialReasons({ loanId, body }) {
    return this.#http.post(`/LoanDenialReasons/loan/${loanId}/update-all`, body);
  }
}
